import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useFormik } from "formik";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { actions } from "../redux/authRedux";
import * as Yup from "yup";
import "../../src/assets/css/login.css";
import Spinner from "../component/Spinner";
import sign from "jwt-encode";
import { useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import noibo from "../assets/images/BHS_Property_logo.png";
import crmlogo from "../assets/images/crm-logo.png";

export default function Login() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({ isAuthorized: auth.user != null }),
    shallowEqual
  );

  const { hash } = useParams();

  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();

  const createConfig = (_token) => {
    return {
      headers: {
        'Authorization': 'Bearer ' + _token,
        'Content-Type': 'application/json; charset=UTF-8',
        'search': ''
      }
    }
  }

  const ValidSchema = Yup.object().shape({
    username: Yup.string().trim().nullable().required("Vui lòng nhập tên đăng nhập"),
    password: Yup.string().trim().nullable().min(6, "Mật khẩu có độ dài tối thiểu 6 ký tự").max(150, "Mật khẩu có độ dài tối đa 150 ký tự").required("Vui lòng nhập mật khẩu"),
  });


  const formik = useFormik({
    initialValues: { username: '', password: '' },
    validationSchema: ValidSchema,
    onSubmit: (values, { setSubmitting }) => {
      const secure = sign(values, "O*FMA7|elQaygz0*");
      setLoading(true)
      Axios.post(URL_LIST_ALL + "login", { data: secure })
        .then((res) => {
          setSubmitting(false);
          setLoading(false)
          if (res.data.status === "success") {
            let user = res.data;
            user.config = createConfig(res.data.access_token);
            // console.log(user);
            dispatch(actions.login(user));
          } else alert(res.data.message)
        }).catch((err) => { console.log(err); setLoading(true) });
    },
  });

  useEffect(function () {
    if (Cookies.get('ssohash') && Cookies.get('ssohash') !== '' && Cookies.get('ssohash') !== 'logout') {
      let ssohash = Cookies.get('ssohash')
    }
  }, [hash]);

  return (
    <div>
      {isAuthorized ? (
        <Navigate to="/" />
      ) : (
        <div className="w-100 layout-login bg-backdrop">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-6">
                <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-100 bg-backdrop">
                  <form method="post" onSubmit={formik.handleSubmit} className="flex-fill">
                    <div className="mx-auto mw-450">
                      <div className="text-center mb-4">
                        <img src={crmlogo} className="img-fluid" alt="Logo" />
                      </div>
                      <div className="mb-4">
                        {/* <p>{URL_LIST_ALL}</p> */}
                        <h4 className="mb-2 fs-20">Đăng nhập</h4>
                        {/* <p>Access the CRMS panel using your email and passcode.</p> */}
                      </div>
                      <div className="mb-3">
                        <label className="col-form-label">Tên đăng nhập</label>
                        <div className="position-relative">
                          <span className="input-icon-addon">
                            <i className="far fa-user-circle"></i>
                          </span>
                          <input placeholder="Nhập tên đăng nhập" type="text" value="" className="form-control" {...formik.getFieldProps("username")} />
                        </div>
                        {formik.touched.username && formik.errors.username ? (
                          <div className="text-danger">{formik.errors.username}</div>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <label className="col-form-label">Mật khẩu</label>
                        <div className="position-relative">
                          <input type={show ? 'text' : 'password' } placeholder="Nhập mật khẩu" value="" className="form-control z-index-1" {...formik.getFieldProps("password")}/>
                          <span className="input-icon-addon cursor-pointer" onClick={()=>setShow(!show)}>
                            <i className="fas fa-eye-slash"></i>
                          </span>
                        </div>
                        {formik.touched.password && formik.errors.password ? (
                          <div className="text-danger">{formik.errors.password}</div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <button type="submit" className="btn text-white bg-bhs-color-light w-100" disabled={loading}> {loading ? <Spinner/> : 'Đăng nhập'}</button>
                      </div>

                    </div>
                  </form>
                </div>
              </div>
              <div className="col-12 col-sm-6 d-none d-sm-block bg-bhs-color ">
                <div className="w-100 d-flex justify-content-center align-items-center vh-100">
                  <img src={noibo} alt="logo" width={300} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
